(($)=>{
    "use strict";
    $('.app-access-ratings-slides').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: $('.app-access-ratings .nav .prev'),
        nextArrow: $('.app-access-ratings .nav .next'),
        responsive: [
            { breakpoint: 2500 },
            { breakpoint: 2160 },
            { breakpoint: 1860 },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

})(jQuery)